import React, { useState } from "react";
import {
  Container,
  MainContainer,
  SideContainer,
  FormRegister,
} from "./styled";
import { Link } from "react-router-dom";
import Turnstile, { useTurnstile } from "react-turnstile";

const RegisterContainer = (props) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    handleRegister,
    errorMessage,
    name,
    setName,
    typeOfUser,
    setTypeOfUser,
  } = props;
  const turnstile = useTurnstile();
  const [status, setStatus] = useState(null);

  return (
    <Container>
      <SideContainer>
        <Link to="/">
          <img src="/assets/Logo.png" alt="Logo Deportactico" />
        </Link>
        <h1>Registrarse</h1>
        <p>
          Ya tenés una cuenta?{" "}
          <Link to="/app/login">
            <strong>Inicia sesion</strong>
          </Link>
        </p>
        <FormRegister
          onSubmit={(e) => {
            e.preventDefault();
            handleRegister();
          }}
        >
          <div>
            <input
              className="input"
              name="name"
              type="text"
              placeholder="Nombre completo"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <input
              className="input"
              name="email"
              type="email"
              placeholder="Mail"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <Turnstile
              sitekey="0x4AAAAAAAWaSNDXYMG4HUaG"
              onError={() => setStatus("error")}
              onExpire={() => setStatus("expired")}
              onSuccess={() => setStatus("solved")}
            />
            {status !== null ? <p> {status}</p> : null}
          </div>

          <div>
            <input
              className="input"
              name="email"
              type="password"
              placeholder="Contraseña"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {errorMessage !== null ? <p>{errorMessage}</p> : null}
          </div>
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            <label>Elige la opción que más coincide con vos</label>
            <select onChange={(e) => setTypeOfUser(e.target.value)}>
              <option hidden defaultValue>
                Seleccionar
              </option>
              <option>Entrenador</option>
              <option>Jugador</option>
              <option>Asistente técnico</option>
              <option>Gerenete de club</option>
              <option>Scouter</option>
              <option>Particular</option>
            </select>
          </div>

          <button
            className={typeOfUser === null ? "hidden" : "active"}
            disabled={
              typeOfUser === null ||
              password === null ||
              email === null ||
              name === null
                ? true
                : false
            }
          >
            REGISTRASE
          </button>
        </FormRegister>
      </SideContainer>
      <MainContainer>
        <img
          src="/assets/register-background-img.jpg"
          alt="3d basketball court"
        />
      </MainContainer>
    </Container>
  );
};

export default RegisterContainer;
